<template>
  <div class="diagnosis-box">
    <div class="diagnosis">
      <div class="diagnosis-list">
        <div
          v-for="(list, index) in diagnosList"
          :key="index"
          class="diagnosis-cont"
        >
          <div class="label">{{ list.label }}:</div>
          <div class="value">{{ list.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scrollIndex: 0,
      timer: null
    };
  },
  computed: {
    diagnosList() {
      let diagnosList = [
        [
          {
            label: this.$t("Alarm number"),
            value: "INC220222071316200"
          },
          {
            label: this.$t("Fault Type"),
            value: this.$t("Gears or bearings Damaged")
          },
          {
            label: this.$t("Diagnosis conclusion"),
            value: this.$t("Not enough lubrication")
          },
          {
            label: this.$t("Processing suggestions"),
            value: "REC. Change greases"
          },
          {
            label: this.$t("Diagnosis time"),
            value: "2022-06-14 19:30:12"
          }
        ],
        [
          {
            label: this.$t("Alarm number"),
            value: "INC240229871315430"
          },
          {
            label: this.$t("Fault Type"),
            value: this.$t("Overheating of the pump body")
          },
          {
            label: this.$t("Diagnosis conclusion"),
            value: this.$t("High temperature of inlet gases")
          },
          {
            label: this.$t("Processing suggestions"),
            value: this.$t("Lower inlet gas temperature")
          },
          {
            label: this.$t("Diagnosis time"),
            value: "2021-03-14  19:30:12"
          }
        ]
      ];
      return diagnosList[this.scrollIndex];
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.scrollIndex == 0) {
        this.scrollIndex = 1;
      } else {
        this.scrollIndex = 0;
      }
    }, 5000);
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {},
  components: {}
};
</script>

<style scoped lang="scss">
@import url("../../../../../assets/scss/common.scss");
.diagnosis-box {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  .diagnosis {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    /*需要绑定到元素的 keyframe 名称*/

    .diagnosis-list {
      height: 100%;
      padding: 10px 0;
      display: flex;
      flex-flow: column;
      overflow: auto;
      &:nth-last-child(1) {
        border-bottom: 0;
      }
    }
    .diagnosis-cont {
      width: 100%;
      flex: 1;
      display: flex;
      align-items: center;
      font-size: 16px;
      .label {
        flex: 1;
      }
      .value {
        flex: 1;
        width: 70%;
        padding-left: 35px;
        font-size: 16px;
        line-height: 24px;
        color: #00e7ff;
      }
    }
  }
}

@keyframes animationDown {
  0% {
    transform: translate3d(0, 0, 0);
  }

  100% {
    transform: translate3d(0, -200%, 0);
  }
}
</style>
